import React, { useState, useEffect } from 'react';
import { displayLoader } from '../utils';
import { getStoredData } from '../utils/data-pulls';


const Lineup = (props) => {
    const { 
        teamName = '',
        side = 'home',
        includeTeamName = false,
        lineup = [],
        ...restProps 
    } = props;
    const [ players, setPlayers ] = useState(null);
    const [ subs, setSubs ] = useState(null);
    const [ goalies, setGoalies ] = useState(null);
    const [ officials, setOfficials ] = useState(null);
    const [ isLoaded, setLoaded ] = useState(false);
    const [ lineupStoredData, setLineupStoredData ] = useState([]);

    /**
     * Get the links for individual player pages
     */
    useEffect(() => {
        if ( !lineup ) return;
        
        let args = [
            { 
                key: 'players',
                searchBy: 'lineup',
                lineup: lineup.hasOwnProperty('players') ? lineup.players : null
            }
        ];

        // Get our stored data
        getStoredData(args).then(
            (result) => {

                // Set player data
                if ( result.data.players ) {
                    setLineupStoredData(result.data.players);
                }
                setLoaded(true);
                
            }
        ).catch(
            (error) => {
                setError(error);
            }
        );

        /**
         * Sort lineup of players into players and goalies.
         * Push officials straight to their own array
         */
        if ( Object.keys(lineup).length ) {

            // Sort players into either Players, Goalies, or Subs
            let filteredPlayers = [];
            let filteredSubs = [];
            let filteredGoalies = [];
            if ( lineup.hasOwnProperty('players') ) {
                lineup.players.forEach((player) => {
                    if ( player.hasOwnProperty('starting') && player.starting ) {
                        if ( player.hasOwnProperty('position') && player.position == 'G' ) {
                            filteredGoalies.push(player);
                        } else {
                            filteredPlayers.push(player);
                        }
                    } else {
                        filteredSubs.push(player);
                    }
                });
            }
            setPlayers(filteredPlayers);
            setSubs(filteredSubs);
            setGoalies(filteredGoalies);
            setOfficials( 'officials' in lineup ? lineup.officials : [] );
        }

    }, [lineup]);


    
    useEffect(() => {
        
    }, [lineup]);


    /**
     * Function to get the correct lineup link
     */
    function getLineupLink(uid) {
        const player = lineupStoredData.find(item => item.uid == uid);
        if ( player ) {
            return player.url;
        } else {
            return null;
        }
    }


    /**
     * Check if we're loaded
     */
    if ( !isLoaded ) return displayLoader('acaLoader--main');

    console.log(players);
    /**
     * Return lineup
     */
    return (
        <div className={"lineup lineup--" + side}>

            { includeTeamName ? (
                <h3 className="acaH3 lineup__teamName">{teamName}</h3>
            ) : '' }

            { goalies && goalies.length ? (
                <div className="lineupGroup__wrapper">
                    <h4 className="acaH5--alt lineupGroup__title">GoalKeeper</h4>
                    <ul className="lineupGroup">
                        { goalies.map((player, i) => {
                            return (<LineupLine 
                                key={i} 
                                name={ player.hasOwnProperty('shortName') ? player.shortName : player.hasOwnProperty('name') ? player.name : '' } 
                                title={ 'shirtNumber' in player ? '#' + player.shirtNumber : '' } 
                                link={ getLineupLink(player.personId) }
                            />)
                        }) }
                    </ul>
                </div>
            ) : '' }

            { players && players.length ? (
                <div className="lineupGroup__wrapper">
                    <h4 className="acaH5--alt lineupGroup__title">Players</h4>
                    <ul className="lineupGroup">
                        { players.map((player, i) => {
                            return (
                                <LineupLine 
                                    key={i} 
                                    name={ player.hasOwnProperty('shortName') ? player.shortName : player.hasOwnProperty('name') ? player.name : '' } 
                                    title={ 'shirtNumber' in player ? '#' + player.shirtNumber : '' } 
                                    link={ getLineupLink(player.personId) }
                                />
                            )
                        }) }
                    </ul>
                </div>
            ) : '' }

            { subs && subs.length ? (
                <div className="lineupGroup__wrapper">
                    <h4 className="acaH5--alt lineupGroup__title">Substitutes</h4>
                    <ul className="lineupGroup">
                        { subs.map((player, i) => {
                            return (
                                <LineupLine 
                                    key={i} 
                                    name={ player.hasOwnProperty('shortName') ? player.shortName : player.hasOwnProperty('name') ? player.name : '' } 
                                    title={ 'shirtNumber' in player ? '#' + player.shirtNumber : '' } 
                                    link={ getLineupLink(player.personId) }
                                />
                            )
                        }) }
                    </ul>
                </div>
            ) : '' }

            { officials && officials.length ? (
                <div className="lineupGroup__wrapper">
                    <h4 className="acaH5--alt lineupGroup__title">Officials</h4>
                    <ul className="lineupGroup">
                        { officials.map((player, i) => {
                            return (
                                <LineupLine 
                                    key={i} 
                                    name={ player.hasOwnProperty('shortName') ? player.shortName : player.hasOwnProperty('name') ? player.name : '' } 
                                    title={ 'role' in player ? player.role : '' } 
                                />
                            )
                        }) }
                    </ul>
                </div>
            ) : '' }
        

        </div>
    );
}

const LineupLine = (props) => {
    const { 
        name = '',
        title = '',
        link = '',
        ...restProps 
    } = props;

    return (
        <li className="lineupItem">
            { link ? (
                <a href={link} className="lineupItem__inner">
                    <span className="lineupItem__name">{name}</span>
                    <span className="lineupItem__position">{title}</span>
                </a>
            ) : (
                <span className="lineupItem__inner">
                    <span className="lineupItem__name">{name}</span>
                    <span className="lineupItem__position">{title}</span>
                </span>
            ) }
        </li>
    );

}



/**
 * Export
 */
export { Lineup };